import { useQuery } from "@tanstack/react-query";
import { Skill } from "@/model";
import skillRepository from "@/repository/skillRepository";


const getData = async (agentId?: number, keyword?: string, searchType?: "intent" | "intentSentence") => {
    if (!agentId)
        return [];

    const res = await skillRepository.findWithIntent(agentId, keyword, searchType);
    return res.data?.data;
};

export const useSkills = (agentId?: number, keyword?: string, searchType?: "intent" | "intentSentence") => {
    return useQuery<Skill[]>({
        queryKey: ["skill", "agent", agentId, keyword, searchType],
        queryFn: async () => getData(agentId, keyword, searchType),
        retry: false
    });
};
